module.exports = __webpack_public_path__ + "img/tips1_botlist7img5.f93793cb.png";